/*
 DashboardTemplateHome is the landing page when a user clicks "My Dashboards".
 It facilitates the abilities to both edit and create custom dashboards.
*/
import { Component, OnInit, ViewChild, ComponentFactoryResolver } from '@angular/core';
import { DashboardTemplateService } from './dashboard-template.service';
import { DataLayerService } from './data-layer.service';
import { UsersService } from './users.service';
import { ConfigService } from './config.service';
import { ConfirmationService } from 'primeng/api';
import { ColorPickerModule } from 'primeng/colorpicker';
import { MessageService } from 'primeng/api';
import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';
import { takeWhile } from 'rxjs/operators';

declare var $;

enum useCase {
	copy = 0,
	new
}

@Component({
	selector: 'dashboard-template-home-component',
	templateUrl: 'dashboard-template-home.component.html',
	styleUrls: ['dashboard-template-home.component.css'],
	providers: [ConfirmationService, MessageService],

	animations: [
		trigger('buttonState', [
			state('inactive', style({
				opacity: 0
			})),
			state('active', style({
				opacity: 1
			})),
			transition('inactive => active', animate('500ms ease-in')),
			transition('active => inactive', animate('500ms ease-out'))
			])
	]
	/*
	animations: [
		trigger('buttonState', [
			state('in', style({
				opacity: 0
			})),
			transition('void => *', [
				animate('3s', keyframes([
					style({opacity: 0, offset: 0}),
					style({opacity: 1, offset: 0.5})
				])),
			]),
			transition('* => void', [
				animate('3s', keyframes([
					style({opacity: 1, offset: 0}),
					style({opacity: 0, offset: 0.5})
				])),
			])
	])
	]
	*/
})

export class DashboardTemplateHomeComponent implements OnInit {
// @ViewChild(DashboardTemplateDirective) dashboardTemplateHost: DashboardTemplateDirective;

dashboardTemplateService: DashboardTemplateService;
templates: any[] = [];
templateList: any[] = [];
existingTemplate: any;
existingTemplateDelete: any;
existingTemplateIdToCopy: any;
useCases: any[] = [];
selectedUseCase: any;
dashboardTitle: string;
templateElements: any[] = [];
previewTemplateCounter = 0;

// template-wide variables
// filter the list of stations
stationFilter;
stationFilterVisible;
stationFilterOptions: any[] = [
	{label: 'No filter - display all stations', value: 'all'},
	{label: 'Filter (comma separated)', value: 'filter'}
];
stationFilterText;

chartTypes: any[] = [
	{label: 'column', value: 'column'}, 
	{label: 'line', value: 'line'}, 
	{label: 'scatter', value: 'scatter'}];
symbolTypes: any[] = [
	{label: 'circle', value: 'circle'}, 
	{label: 'diamond', value: 'diamond'}, 
	{label: 'square', value: 'square'}, 
	{label: 'triangle', value: 'triangle'}, 
	{label: 'triangle-down', value: 'triangle-down'}, 
	{label: 'url(graphic.png)', value: 'url(graphic.png)'} ];
dataTypes: any[] = [];
stationID: any[] = [];
yAxisLabelOptions: any[] = [
	{label: 'Label (${units})', value: 'Label (${units})'}];
yAxisDirectionOptions: any[] = [
	{label: 'standard', value: false}, 
	{label: 'reversed', value: true}];
seriesIdentifierOptions: any[] = [{label: 'locID', value: 'locID'}];
station_id_element: string;
yAxisEnabled = true;
availableStatistics = null;
msgs: any[] = [];
stationTSArray: any[] = [];
stationList: any[] = [];
templateNameWarningVisible;
systemDashboardWarningVisible;
systemDashboardDeleteWarningVisible;
deleteButtonLabel='Delete';
idAlreadyInUseVisible;
templateSaved;
hasMap;
hasImages;
stateDashboardSaved = 'inactive';
showStationSelectorOnChart = false;
allStatisticsPossible: any[] = [];
draggedChart: any = null;
draggedChartStartIndex;
draggedChartStartY;
draggedChartEndY;
templatesObserver$


constructor(
	dashboardTemplateService: DashboardTemplateService,
	private confirmationService: ConfirmationService,
	private usersService: UsersService,
	private messageService: MessageService,
	private configService: ConfigService,
	private dataLayerService: DataLayerService ) {

		this.dashboardTemplateService = dashboardTemplateService;
		// this.yAxisLabelOptions.push ({label: 'Label (${units})', value: 'Label (${units})'});
		// this.yAxisDirectionOptions.push ({label: 'Standard', value: false});
		// this.yAxisDirectionOptions.push ({label: 'Reversed', value: true});
	}

	ngOnInit () {
		this.templateNameWarningVisible = false;
		this.systemDashboardWarningVisible = false;
		this.systemDashboardDeleteWarningVisible = false;
		this.idAlreadyInUseVisible = false;
		this.templateSaved = false;
		this.templatesObserver$ = this.dashboardTemplateService.configurationCompleteObserver
		this.templatesObserver$
		  .pipe(takeWhile ( isReady => isReady == false, true ))  // take while configuration is still processing
		  .subscribe( isReady => {
			console.log(isReady);
			if ( isReady == true ) {
				this.templates = this.dashboardTemplateService.getDashboardTemplates();
				// tslint:disable-next-line:forin
				for ( const i in this.templates ) {
					let template: any;

					template = {
						label: this.templates[i].templateDetails.label,
						value: this.templates[i].templateDetails
					};

					this.templateList.push(template);
				}
				console.log(this.templates);
			}
		});

		this.useCases = [
			{ 	'label': 'Copy and modify an existing dashboard',
				'id': useCase.copy,
				'value': useCase.copy },
			{	'label': 'Create a new dashboard',
				'id': useCase.new,
				'value': useCase.new }
		];


		this.setAllDashboardContentDivHidden();
		this.dataLayerService.parseAllStations().then(allStations => {

			this.createChartOptions();
			// console.log(this.stationList);
			// this.useCaseSelected(this.selectedUseCase);
			// console.log(useCase);
			const dataLayer = this.dataLayerService.getDataLayerDetails('allStations');
			this.station_id_element = dataLayer.stationID;
		});
	}

	toggleState() {
		console.log('In toggleState: ' + this.stateDashboardSaved);
		this.stateDashboardSaved = this.stateDashboardSaved === 'active' ? 'inactive' : 'active';
		console.log('In toggleState: ' + this.stateDashboardSaved);
	}

	// this gets called when the dashboard-template component gets created
	getStationList(list) {
		// console.log(list);
		this.stationList = list;
	}

	//
	// Creates a copy of the existing template the user wants to edit.
	// Sets templateElements to the elements of this existing template.
	// The purpose is to not make changes to the dashboard template until
	// the user is ready.  That way, cancel is still available.
	//
	existingTemplateSelected(existingTemplate) {
		// console.log (existingTemplate);
		this.setTemplateWideSelections(existingTemplate);

		// Set templateElements to this element.
		// This actually creates a new element, not
		// just a pointer to the existing template element.
		this.templateElements = this.cloneObj(existingTemplate.elements);
		this.activateGUIElements ( this.templateElements );
		this.previewTemplateCounter++;

		this.setElementVisible('workSpaceTitle');
		document.getElementById('workSpaceTitle').innerHTML = 'Edit ' + existingTemplate.label;
		this.setElementVisible('workspace');
		this.setElementVisible('previewArea');
		this.setElementVisible('saveExistingTemplateButton');
		this.setElementVisible('cancelButton');
		this.setElementHidden('saveNewTemplateButton');
		this.setElementHidden('dashboardTitleDiv');
		this.setElementHidden('deleteExtras');

		// If the template is system wide rather than user-defined,
		// warning user that changes will not be saved.
		if ( existingTemplate.source === 'Config' ) {
			this.systemDashboardWarningVisible = true;
		} else {
			this.systemDashboardWarningVisible = false;
		}

		// Clear the selected use case if user had clicked to create a new dashboard.
		this.selectedUseCase = null;
		this.templateSaved = false;
		this.stateDashboardSaved = 'inactive';
	}

	//
	// The purpose is not to delete the dashboard template until
	// the user is ready.  That way, cancel is still available.
	//
	existingTemplateSelectedToDelete(existingTemplate) {
		console.log (existingTemplate);


		// If the template is system wide rather than user-defined,
		// warning user that changes will not be saved.
		if ( existingTemplate.source === 'Config' ) {
			this.systemDashboardDeleteWarningVisible = true;
		} else {
			this.deleteButtonLabel = 'DELETE ' + existingTemplate.label;
			this.setElementVisible ("deleteExtras");
			this.systemDashboardDeleteWarningVisible = false;
		}

		// Clear the selected use case if user had clicked to create a new dashboard.
		this.selectedUseCase = null;
		this.templateSaved = false;
		this.stateDashboardSaved = 'inactive';
	}

	//
	// Creates a copy of an existing template.
	// Sets templateElements to the elements of an existing template.
	//
	existingTemplateToCopySelected(existingTemplate) {
		// console.log (existingTemplate);
		// Set templateElements to this element.
		// This actually creates a new element, not
		// just a pointer to the existing template element.
		this.templateElements = this.cloneObj(existingTemplate.elements);
		this.setTemplateWideSelections(null);
		this.activateGUIElements ( this.templateElements );
		this.previewTemplateCounter++;

		this.setElementVisible('workSpaceTitle');
		document.getElementById('workSpaceTitle').innerHTML = 'New Dashboard Elements';
		this.setElementVisible('previewArea');
		this.setElementVisible('workspace');
		this.setElementHidden('saveExistingTemplateButton');
		this.setElementVisible('saveNewTemplateButton');

		this.templateSaved = false;
		this.stateDashboardSaved = 'inactive';
	}

	// Set the template wide variables, such as filter the station selection list.  If existingTemplate is null, this is a new template.
	setTemplateWideSelections(existingTemplate)
	{
		if ( existingTemplate != null &&
			existingTemplate.hasOwnProperty('filterDefault') &&
			existingTemplate.filterDefault.length > 0 ) {
				this.stationFilter = 'filter';
				this.stationFilterVisible = true;
				this.stationFilterText = existingTemplate.filterDefault.join();
		} else {
				this.stationFilter = 'all';
				this.stationFilterVisible = false;
				this.stationFilterText = '';
		}
	}
	// user changed filter preference - show filter text box
	stationFilterChanged(event) {
		console.log(event);
		if ( event === 'filter') {
				this.stationFilterVisible = true;
		} else { // all
				this.stationFilterVisible = false;
		}
	}

	// Certain elements on the configuration exist only for GUI purposes such as 
	// yAxisEnabled is false if the following exists in the configuration:
	// 		{ 'yAxis': {'lineWidth': 0, 'title': {'enabled': false}, 'labels': { 'enabled': false }, 'linkedTo': 0};
	// yAxisReversed is explicitly false/true if the following exists:
	// 		{ 'yAxis': {'reversed': false/true})
	activateGUIElements ( templateElements ) {
		// console.log(templateElements);
		this.checkForSingleElements ();

		for ( let i = 0; i < templateElements.length ; i++ ) {
			if ( templateElements[i].type == 'chart' && templateElements[i].hasOwnProperty('data')) {
				const data = templateElements[i].data;
				// console.log('in activateGUIElements');
				for ( let j = 0; j < data.length; j++ ) {
					const element = data[j];
					// 
					// yAxis settings
					//
					if ( element.hasOwnProperty('yAxis')) {
						console.log('element has yAxis');
						// yAxis.reversed
						if ( element.yAxis.hasOwnProperty('reversed')) {
							element.yAxisReversed = element.yAxis.reversed;
						}
						if ( element.yAxis.lineWidth == 0 &&
							 element.yAxis.title?.enabled == false &&
							 element.yAxis.labels?.enabled == false ) {
								element.yAxisEnabled = false;
						} else {
								element.yAxisEnabled = true;
						}
					}
					else {
						element.yAxisEnabled = true;
					}
				}
			}
		}
		// console.log(templateElements);
	}

	// If map or images are included, disable those buttons
	checkForSingleElements () {
		let hasMap = false;
		let hasImages = false;
		for ( let i = 0; i < this.templateElements.length ; i++ ) {
			if ( this.templateElements[i].type == 'map' ){
				hasMap = true;
			}
			if ( this.templateElements[i].type == 'images' ){
				hasImages = true;
			}
		}
		this.hasMap = hasMap;
		this.hasImages = hasImages;
	}

	//
	// Sets elements visible based on the use case selected
	// by the user.
	//
	useCaseSelected(useCasePassed) {
		this.setAllDashboardContentDivHidden();

		// Clear the selected dashboard if user had clicked to edit an existing dashboard.
		this.existingTemplate = null;

		if ( this.selectedUseCase === useCase.new ) {
			this.setElementVisible('dashboardTitleDiv');
			this.setElementVisible('workSpaceTitle');
			document.getElementById('workSpaceTitle').innerHTML = 'New Dashboard Elements';
			this.setElementVisible('previewArea');
			this.setElementVisible('workspace');
			this.setElementVisible('redrawPreviewButton');
			this.setElementHidden('saveExistingTemplateButton');
			this.setElementVisible('saveNewTemplateButton');
			this.setElementVisible('cancelButton');
			this.setTemplateWideSelections(null);
			this.showStationSelectorOnChart = true;
			this.previewTemplateCounter++;
		} else if ( this.selectedUseCase === useCase.copy ) {
			console.log('Copy existing template');
			this.setElementVisible('redrawPreviewButton');
			this.setElementVisible('dashboardTitleDiv');
			this.setElementVisible('existingTemplateList');
			this.setElementVisible('cancelButton');
			this.previewTemplateCounter++;
		} 
	}

	//
	// Sets all new dashboard elements to hidden.
	//
	setAllDashboardContentDivHidden() {
		this.setElementHidden('dashboardTitleDiv');
		this.setElementHidden('existingTemplateList');
		this.setElementHidden('workSpaceTitle');
		this.setElementHidden('saveExistingTemplateButton');
		this.setElementHidden('saveNewTemplateButton');
		this.setElementHidden('redrawPreviewButton');
		this.setElementHidden('cancelButton');
		this.setElementHidden('workspace');
		this.setElementHidden('previewArea');
		this.setElementHidden('deleteExtras');
		this.templateSaved = false;
		this.stateDashboardSaved = 'inactive';
		this.showStationSelectorOnChart = false;
		this.templateNameWarningVisible = false;
		this.systemDashboardWarningVisible = false;

		// resets the p-dropdown to no template selected
		this.existingTemplate = null;
		this.dashboardTitle = null;
		this.templateElements = [];
	}

	//
	// Sets an individual element to hidden
	//
	setElementHidden(id) {
		document.getElementById(id).style.display = 'none';
		// document.getElementById(id).style.visibility = 'hidden';
	}

	//
	// Sets an individual element to visible
	//
	setElementVisible(id) {
		document.getElementById(id).style.display = 'initial';
		// document.getElementById(id).style.visibility = 'visible';
	}

	//
	// Delete the given element from the current working
	// template.
	//
	deleteElement(element) {
		console.log ('Delete element');
		console.log(element);
		this.confirmDelete(element);
	}

	//
	// The template elements have been created.  Now save to the list of templates.
	//
	deleteDashboard() {
		// console.log('Attempting to delete dashboard.', 
		// 		this.existingTemplateDelete, this.templates, this.templateList );

		let deleteIndex = -1;
		for ( const i in this.templates ) {
			if ( this.templates[i]['templateDetails']['id'] === this.existingTemplateDelete.id ) {
				console.log('Template index: ' + this.existingTemplateDelete.id + ' ' + i);
				deleteIndex = +i;
			}
		}

		if ( deleteIndex != -1 ) {

			// This call deletes this template from the list of templates and updates
			// the left side menu list of dashboards.
			this.configService.getAppReference().deleteDashboardTemplateDefinition ( deleteIndex );

			this.templateList.splice(deleteIndex, 1);

			// Update the list of templates so the list of existing templates available
			// to edit at the top of this page excludes this recent removal.
			const templates = this.dashboardTemplateService.getDashboardTemplates();
			if ( this.configService.isARealUser() ) {
				// console.log(wsTemplateElements);
				this.dashboardTemplateService.deleteTemplate(templates[deleteIndex]);

				this.usersService.deleteDashboardTemplate(this.configService.userName, this.existingTemplateDelete);
			}

			// GUI actions...
			this.previewTemplateCounter--;
			this.setAllDashboardContentDivHidden();
			this.templateSaved = true;
			this.stateDashboardSaved = 'active';
		}
	}

	getStationFilterArray() {
		return ( this.stationFilter === 'all' ? [] : this.stationFilterText.split(','));
	}

	//
	// The template elements have been created.  Now save to the list of
	// templates.
	//
	saveNewTemplate() {
		console.log('Attempting to save template.', this.templates);
		if ( this.dashboardTitle == null || this.dashboardTitle.length === 0 ) {
			this.templateNameWarningVisible = true;
		} else {
			// the id becomes the title with spaces removed
			const id = this.dashboardTitle.replace(/\s/g, '');
			for ( const i in this.templates ) {
				if ( this.templates[i]['templateDetails']['id'] === id ) {
					this.idAlreadyInUseVisible = true;
					return;
				}
			}


			// console.log("Save new template.");
			this.templateNameWarningVisible = false;

			const urlString = '/dashboardTemplate//-999?id=' + id;
			console.log(urlString);
			const element = {
				elements: this.templateElements,
				id: id,
				label: this.dashboardTitle,
				url: urlString,
				filterDefault: this.getStationFilterArray()
			};

			// This call adds this new template to the list of templates and updates
			// the left side menu list of dashboards.
			this.configService.getAppReference().addDashboardTemplateDefinition ( element );

			// Update the list of templates so the list of existing templates available
			// to edit at the top of this page includes this recent addition.
			const templates = this.dashboardTemplateService.getDashboardTemplates();
			const template = {
						label: this.templates[templates.length - 1].templateDetails.label,
						value: this.templates[templates.length - 1].templateDetails
				};

			this.templateList.push(template);
			if ( this.configService.isARealUser() ) {
				const wsTemplateElements = this.createCleanDashboardData(element);
				// console.log(wsTemplateElements);
				this.usersService.addDashboardTemplate(this.configService.userName, wsTemplateElements);
			}

			// GUI actions...
			this.previewTemplateCounter++;
			this.setAllDashboardContentDivHidden();
			this.templateSaved = true;
			this.stateDashboardSaved = 'active';
		}
	}

	// Helper function to createCleanDashboardData.
	// If origObj.property exists and is not set to default, copy to newObj.property
	checkForItem(origObj, newObj, property) {
		console.log('Checking for ' + property );
		if ( origObj.hasOwnProperty(property) && origObj[property] != 'default') {
			newObj[property] = origObj[property];
		}
		console.log(newObj);
	}

	// Given a full template, strip out only the parts needed for configuration.
	// Return this cleaned version.
	// Any items needed for configuration must be added here.
	createCleanDashboardData(template) {
		console.log(template);
		const newTemplate = { 
			'label': template.label,
			'id': template.id,
			'filterDefault': this.getStationFilterArray() 
		};
		const elementsArray = [];
		const len = template.elements.length;
		for ( let i = 0; i < len; i++ ) {
			const newElement = { 'type': template.elements[i].type };
			if ( template.elements[i].hasOwnProperty('data')) {
				const newDataArray = [];
				const len2 = template.elements[i].data.length;
				for ( let j = 0; j < len2; j++ ) {
					const newDataItem = {};
					this.checkForItem ( template.elements[i].data[j], newDataItem, 'station_id');
					this.checkForItem ( template.elements[i].data[j], newDataItem, 'dataType');
					this.checkForItem ( template.elements[i].data[j], newDataItem, 'color');
					this.checkForItem ( template.elements[i].data[j], newDataItem, 'chartType');
					this.checkForItem ( template.elements[i].data[j], newDataItem, 'statisticType');
					this.checkForItem ( template.elements[i].data[j], newDataItem, 'duration');
					this.checkForItem ( template.elements[i].data[j], newDataItem, 'yAxisLabel');
					this.checkForItem ( template.elements[i].data[j], newDataItem, 'yAxisLabelPrecision');
					this.checkForItem ( template.elements[i].data[j], newDataItem, 'tooltipPrecision');
					this.checkForItem ( template.elements[i].data[j], newDataItem, 'yAxis');
					this.checkForItem ( template.elements[i].data[j], newDataItem, 'seriesIdentifier');
					this.checkForItem ( template.elements[i].data[j], newDataItem, 'symbol');
					newDataArray.push(newDataItem);
				}
				newElement['data'] = newDataArray;
			}
			elementsArray.push (newElement);
		}
		newTemplate['elements'] = elementsArray;
		return newTemplate;
	}

	//
	// Move all templateElements back to edited dashboard templates.
	//
	saveExistingTemplate() {
		this.existingTemplate.elements = this.cloneObj(this.templateElements);
		this.existingTemplate.filterDefault = this.getStationFilterArray();

		// Update user web services but remove any time series first
		if ( this.configService.isARealUser() ) {
			const wsTemplateElements = this.createCleanDashboardData(this.existingTemplate);
			console.log(wsTemplateElements);
			this.usersService.addDashboardTemplate(this.configService.userName, wsTemplateElements);
		}
		this.templateElements = [];
		this.previewTemplateCounter++;
		this.setAllDashboardContentDivHidden();
		// this.informationalDialog('Changes saved.');
		this.templateSaved = true;

		// console.log("Calling toggleState");
		// this.toggleState();
		// setTimeout(this.toggleState, 6000);

		this.stateDashboardSaved = 'active';
		// resets the p-dropdown to no template selected
		this.existingTemplate = null;
	}

	cancelTemplate() {
		this.previewTemplateCounter++;
		this.setAllDashboardContentDivHidden();
		// this.informationalDialog('Changes not saved.');
		this.selectedUseCase = {label: null, value: null};  // for some reason setting to null is not adequate here ???
	}

	//
	// The user is typing in the template name field
	//
	enteringTemplateName() {
		if ( this.dashboardTitle == null || this.dashboardTitle.length === 0 ) {
			this.templateNameWarningVisible = true;
		} else {
			this.templateNameWarningVisible = false;

			// Also check for a duplicate name.
			//
			// the id becomes the title with spaces removed
			this.idAlreadyInUseVisible = false;
			const id = this.dashboardTitle.replace(/\s/g, '');
			for ( const i in this.templates ) {
				if ( this.templates[i]['templateDetails']['id'] === id ) {
					this.idAlreadyInUseVisible = true;
					return;
				}
			}
		}
	}

	//
	// confirmation dialog code
	//
	confirmDelete(element) {
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete this element?',
			accept: () => {
				this.templateElements = this.templateElements.filter(obj => obj !== element );
				this.previewTemplateCounter++;
				this.checkForSingleElements();
				console.log(this.templateElements);
			}
		});
	}

	//
	// information dialog code
	//
	informationalDialog(message) {
		this.confirmationService.confirm({
			message: 'Changes have been saved.',
			accept: () => {
			}
		});
	}

	//
	// The following routines add a component to the currently selected dashboard
	//
	addAChart() {
		this.templateElements.push (
			{ 'type': 'chart',
				'data': [{
					'dataType': 'Precip-Total',
					'color': 'cyan',
					'chartType': 'column',
					'statisticType': 'Total',
					'duration': '1Hour',
					'yAxisEnabled': true
				}]
			});
		this.previewTemplateCounter++;
		console.log(this.templateElements);
	}

	addAMap() {
		this.templateElements.push ( { 'type': 'map'});
		this.previewTemplateCounter++;
		console.log(this.previewTemplateCounter);
		this.checkForSingleElements();
	}

	addImages() {
		this.templateElements.push ( { 'type': 'images' });
		this.previewTemplateCounter++;
		console.log(this.previewTemplateCounter);
		this.checkForSingleElements();
	}

	addTS(element, element_index, ts_index) {
		element.data.splice(ts_index + 1, 0, {
					'dataType': 'Precip-Total',
					'color': 'cyan',
					'chartType': 'column',
					'statisticType': 'Total',
					'duration': '1Hour',
					'yAxisEnabled': true
				});
		this.previewTemplateCounter++;
	}

	deleteTS(element, element_index, ts_index) {
		if ( !element.hasOwnProperty('data') || element.data.length <= 1 ) {
			this.deleteElement(element);
		} else {
			element.data.splice(ts_index, 1);
			this.previewTemplateCounter++;
		}
	}

	redrawPreview() {
		this.previewTemplateCounter++;
		console.log(this.templateElements);
		// console.log(this.templateElements[1].data[0].station_id); // why 1?
	}

	// createChartOptions is called one time to create
	// a list of all stations as well as all datatype, statistics, and duration
	// combinations.
	createChartOptions() {
		const dataLayer = this.dataLayerService.getDataLayerDetails('allStations');
		const allStations = dataLayer.value;
		const stations = allStations['stationSummaries'];

		// console.log(stations);
		this.stationTSArray = stations;
		this.allStatisticsPossible = this.getAllStationAvailableData();
		console.log(this.allStatisticsPossible);
	}

	// When one of the work area elements are opened, this routine is called.
	// Need to fill in good options for the data types, statistics and duration pulldowns.
	elementOpened(element) {
		// console.log(element);
		let i = 0;
		const dataLayer = this.dataLayerService.getDataLayerDetails('allStations');
		const stations = dataLayer.value.stationSummaries;
		const station_id_field = dataLayer.stationID;
		for ( i = 0; i < element.data.length; i++ ) {
			if ( element.data[i].hasOwnProperty('station_id') && element.data[i].station_id != null ) {
				const station = stations.filter(dl => dl[station_id_field] === element.data[i].station_id)[0];
				// console.log(station);
				element.data[i]['dataPossible'] = this.getStationAvailableData(station);
			}
			// console.log(element.data[i].dataPossible);
			this.setElementDataTypes(element, i);
		}
	}

	//
	//  A new station within a work area chart element has been selected.  Fill in the Station Data Type pulldown.
	//  This also is called when the user clicks the x to clear the pulldown selection.
	//
	newStationSelected(station_id, element, element_index, ts_index) {
		if ( station_id == null ) {
			// The station pulldown selection has been cleared.
			// Set statistics possible to all statistic available.
			element.data[ts_index]['dataPossible'] = this.allStatisticsPossible;
			this.setElementDataTypes(element, ts_index);
			delete element.station_id;
		} else {
			// A specific station has been selected.
			const station_id_n = +station_id;
			const dataLayer = this.dataLayerService.getDataLayerDetails('allStations');
			const stations = dataLayer.value.stationSummaries;
			const station_id_field = dataLayer.stationID;

			const station = stations.filter(dl => dl[station_id_field] === station_id_n)[0];

			if ( station != null ) {
				// dataPossible is an array of time series identifiers composed of dataType
				element.station_id = station_id;
				element.data[ts_index]['dataPossible'] = this.getStationAvailableData(station);
				this.setElementDataTypes(element, ts_index);
			}
		}
	}

	//
	// setElementDataTypes creates an array of dataTypes for the element's jth
	// data 'dataTypes' using the element.dataPossible array.
	//
	setElementDataTypes(element, j) {
		// console.log(element);
		// console.log(j);
		const dataTypesArray = [];
		// if the dataPossible element hasn't yet been assigned, let's assign the universal dataPossible created using all stations.
		if ( !element.data[j].hasOwnProperty('dataPossible')) {
			element.data[j].dataPossible = this.allStatisticsPossible;
		}

		element.data[j].dataPossible.forEach( function(item) {
			dataTypesArray.push({'label': item.dataType, 'value': item.dataType});
		});
		element.data[j]['dataTypes'] = dataTypesArray;

		console.log(element, j);
		this.setElementStatisticTypes(element, j);
	}
	elementDataTypeSelected ( event ) {
		console.log(event );
	}

	// Based on the currently selected data type,
	// setElementStatisticType creates a list of available statistics
	// and set the element's jth data 'statisticTypes' to this list
	// using the elements.dataPossible array.
	setElementStatisticTypes(element, j) {
		// console.log(element);
		if ( !element.data[j].hasOwnProperty('dataPossible')) {
			return;
		}

		const statisticTypesArray = [];
		let dataTypeFound = false;
		// console.log(element.data[j].stationDataType);

		for (const item of element.data[j].dataPossible) {
			// console.log(item.dataType);
			// if ( item.dataType === element.data[j].stationDataType ) {
			if ( item.dataType === element.data[j].dataType ) {
				dataTypeFound = true;
				item.statisticTypes.forEach ( function (sitem) {
					statisticTypesArray.push({'label': sitem.statisticType, 'value': sitem.statisticType});
				});
			}
			if ( dataTypeFound === true ) {
				break;
			}
		}
		element.data[j]['statisticTypes'] = statisticTypesArray;
		this.setElementDurations(element, j);
	}

	// Based on the currently selected data type and statistic type,
	// setElementDurations creates a list of available durations and
	// sets the elements jth data 'durations' to this list
	// using the elements.dataPossible array.
	setElementDurations(element, j) {
		// console.log(element);
		if ( !element.data[j].hasOwnProperty('dataPossible')) {
			return;
		}

		const durationsArray = [];
		let dataTypeFound = false;
		let statisticFound = false;
		// console.log(element.data[j].stationDataType);

		for (const item of element.data[j].dataPossible) {
			// console.log(item.dataType);
			// if ( item.dataType === element.data[j].stationDataType ) {
			if ( item.dataType === element.data[j].dataType ) {
				dataTypeFound = true;
				// item.statisticTypes.forEach ( function (sitem) {
				for (const sitem of item.statisticTypes) {
					if ( sitem.statisticType === element.data[j].statisticType) {
						statisticFound = true;
						sitem.durations.forEach ( function (d) {
							console.log(d);
							if ( d != null ) {
								durationsArray.push({'label': d, 'value': d});
							}
						});
					}
					if ( statisticFound === true ) {
						break;
					}
				}

			}
			if ( dataTypeFound === true ) {
				break;
			}
		}
		element.data[j]['durations'] = durationsArray;
	}

	// When a chart contains multiple time series, it may be desirable to limit the number of y-axis labels as well as
	// display multiple charts on the same scale (not 1 y axis that goes from 1-10 and the other from 1-1000).  In those
	// cases, setting the linkedTo attribute allows this behavior.
	// Based on the number of time series on a chart, create a list of linked to options for the yaxis
	setElementLinkedToOptions(element, j) {
		// console.log(element);
		const linkedToOptions = [];

		for (let i = 0; i < element.data.length; i++ ) {
			// don't give the option of itself
			if ( i != j ) {
				const label = 'TS ' + (i+1);
				linkedToOptions.push({'label': label, 'value': i});
			}
		}
		element.data[j]['linkedToOptions'] = linkedToOptions;
	}

	// sets the yAxis component for highcharts
	// property is the property name for internal tracking ('yAxisReversed')
	// associatedProperty is the yAxis: { associatedProperty: value } for highcharts (yAxis: { 'reversed': false })
	setYAxis ( element, j, property, associatedProperty ){
		if ( element.hasOwnProperty('data') && element.data.length <= (j+1) ) {
			const e = element.data[j];
			if ( e.hasOwnProperty(property)){
				const value= e[property]
				const newObj = { [associatedProperty]: value };
				const yAxis = e.hasOwnProperty(associatedProperty) ? e[associatedProperty] : {};
				console.log(newObj, yAxis);
				e['yAxis'] = { ...yAxis, ...newObj };
				console.log(e);
			}
		}
	}

	// If yAxisEnabled is false, set yAxis =
	// 		{'lineWidth': 0, 'title': {'enabled': false}, 'labels': { 'enabled': false }, 'linkedTo': 0};
	// otherwise, remove those components from the configuration
	yAxisEnabledClicked (element, j) {
		console.log(element);
		if ( element.hasOwnProperty('data') && element.data.length <= (j+1) ) {
			const e = element.data[j];
			console.log(e);
			if ( e.yAxisEnabled == false ) {
					const yAxis = e.hasOwnProperty('yAxis') ? e['yAxis'] : {};
					const newObj = {'lineWidth': 0, 'title': {'enabled': false}, 'labels': { 'enabled': false }, 'linkedTo': 0};
					console.log(yAxis, newObj);
					e['yAxis'] = { ...yAxis, ...newObj };
					console.log(e['yAxis']);
					console.log(e.yAxis?.lineWidth);
			} else {
					delete e.yAxis?.lineWidth;
					delete e.yAxis?.linkedTo;
					delete e.yAxis?.title?.enabled;
					if ( e.yAxis?.title.length == 0 )
						delete e.yAxis.title;
					delete e.yAxis?.labels?.enabled;
					if ( e.yAxis?.labels.length == 0)
						delete e.yAxis.label;
			}
			console.log(e, this.templateElements );
		}
	}

	// remove the property from the element
	resetElement ( element, j, property) {
		console.log ( element, j, property);
		if ( element.hasOwnProperty('data') && element.data.length <= (j+1) ) {
			if ( element.data[j].hasOwnProperty(property)) {
				delete element.data[j][property];
			}
	}
	}
	// remove the property on the element as well as the yAxis { associatedProperty: value}
	// if associatedProperty was the only property of yAxis, also remove yAxis
	resetYAxisElement ( element, j, property, associatedProperty ) {
		console.log(element);
		if ( element.hasOwnProperty('data') && element.data.length <= (j+1) ) {
			const e = element.data[j];
			console.log(e);
			// first clear the property
			if ( e.hasOwnProperty(property)) {
				e[property] = null;
			}
			// next clear the yAxis associated property
			if ( e.hasOwnProperty('yAxis') && e.yAxis.hasOwnProperty(associatedProperty)) {
				delete element.data[j]['yAxis'][associatedProperty];
				if ( element.data[j]['yAxis'].length == 0) {
					delete element.data[j]['yAxis'];
				}
			}
			console.log(e);
		}
	}

	//
	// Returns an array of unique dataTypes/statisticTypes/duration combinations
	// 		[
	// 			{	"dataType" : "PrecipAccum",
	// 				"statisticTypes" : [{
	// 					"statisticType": "Total",
	// 					"durations": ["15Minute", "1Hour"]
	// 				},
	// 				{
	// 					"statisticType": "Last",
	// 					"durations": ["15Minute", "Hour"]
	// 				}]
	// 			},
	// 			{	"dataType" : "Precip",
	// 				"statisticTypes" : [{
	// 					"statisticType": "Total",
	// 					"durations": ["15Minute", "1Hour"]
	// 				},
	// 				{
	// 					"statisticType": "Last",
	// 					"durations": ["15Minute", "Hour"]
	// 				}]
	// 			}
	// 		]
	//
	getStationAvailableData (station) {
		// statisticsStrings contains time series identifiers dataType.statisticType.duration.
		// statisticsStrings is only used to find unique combinations of these 3 items.
		const statisticsStrings = [];

		// statistics contains the same information as statisticsStrings but is broken down into an object which is returned
		const statistics = [];

		station.statistics.forEach(function(item) {
			let found = false;
			const statistic = item.dataType + '.' + item.statisticType + '.' + item.duration;

			// Determine if the data type is already present
			statisticsStrings.forEach(function(s) {
				if ( s === statistic ) {
					found = true;
				}
			});

			// If not found, add data type to the list of data types.
			if ( found === false ) {
				statisticsStrings.push ( statistic );

				// now add to statistics
				let foundDataType = false;
				let foundStatisticType = false;
				for ( const s of statistics ) {
					if ( s.dataType === item.dataType ) {
						for ( const st of s.statisticTypes ) {
							if ( st.statisticType === item.statisticType ) {
								// if duration does not exist, add it
								if ( st.durations.indexOf(item.duration) === -1 ) {
									st.durations.push ( item.duration );
								}
								foundStatisticType = true;
								break;
							}
						}
						if ( foundStatisticType === false ) {
							s.statisticTypes.push( { 'statisticType': item.statisticType, 'durations': [item.duration]});
						}
						foundDataType = true;
						break;
					}
				}
				if ( foundDataType === false ) {
					statistics.push( { 'dataType' : item.dataType,
						'statisticTypes': [{ 'statisticType': item.statisticType, 'durations': [item.duration]}]});
				}
			}
		});

		// console.log(statisticsStrings);
		// console.log(statistics);
		return statistics;
	}

	// getAllStationAvailableData does exactly the same thing as getStationAvailableData except it performs
	// available statistics for all stations, creating a comprehensive list.
	getAllStationAvailableData () {

		// statisticsStrings contains time series identifiers dataType.statisticType.duration.
		// statisticsStrings is only used to find unique combinations of these 3 items.
		const statisticsStrings = [];

		// statistics contains the same information as statistics but is broken down into an object which is returned
		const statistics = [];

		for ( const station of this.stationTSArray ) {
		station.statistics.forEach(function(item) {
			let found = false;
			const statistic = item.dataType + '.' + item.statisticType + '.' + item.duration;

			// Determine if the data type is already present
			statisticsStrings.forEach(function(s) {
				if ( s === statistic ) {
					found = true;
				}
			});

			// If not found, add data type to the list of data types.
			if ( found === false ) {
				statisticsStrings.push ( statistic );

				// now add to statistics
				let foundDataType = false;
				let foundStatisticType = false;
				for ( const s of statistics ) {
					if ( s.dataType === item.dataType ) {
						for ( const st of s.statisticTypes ) {
							if ( st.statisticType === item.statisticType ) {
								// if duration does not exist, add it
								if ( item.duration != null && st.durations.indexOf(item.duration) === -1 ) {
									st.durations.push ( item.duration );
								}
								foundStatisticType = true;
								break;
							}
						}
						if ( foundStatisticType === false ) {
							s.statisticTypes.push( { 'statisticType': item.statisticType, 'durations': [item.duration]});
						}
						foundDataType = true;
						break;
					}
				}
				if ( foundDataType === false ) {
					statistics.push( { 'dataType' : item.dataType,
						'statisticTypes': [{ 'statisticType': item.statisticType, 'durations': [item.duration]}]});
				}
			}
		});
		}

		// console.log(statisticsStrings);
		// console.log(statistics);
		return statistics;
	}

	dragStart(event, chart, index) {
		this.draggedChart = chart;
		this.draggedChartStartIndex = index;
		console.log('dragStart');
		console.log(event);
		this.draggedChartStartY = event.screenY;
	}

	dragEnd(event) { // maybe remove this function?
		this.draggedChart = null;
		console.log('dragEnd');
		console.log(event);
	}

	drop(event) {
		console.log('In drop!!');
		console.log(event);
		this.draggedChartEndY = event.screenY;
		if ( this.draggedChart ) {
			const height = event.srcElement.clientHeight;
			const delta = Math.trunc((this.draggedChartEndY - this.draggedChartStartY) / height);
			console.log( this.draggedChartStartIndex );
			// A negative delta indicates the element was drug up, a positive indicates is was drug down.
			const tmpElementHold = this.templateElements.splice ( this.draggedChartStartIndex, 1 );
			this.templateElements.splice ( this.draggedChartStartIndex + delta, 0, tmpElementHold[0]);
			console.log(this.templateElements);
		}

	}

	// utility function to clone an object.
	// source: http://blog.soulserv.net/understanding-object-cloning-in-javascript-part-ii/
	cloneObj( original ) {
		// First create an empty object with
		// same prototype of our original source
		const clone = Object.create( Object.getPrototypeOf( original ) ) ;

		let i, descriptor;
		const keys = Object.getOwnPropertyNames( original ) ;

		for ( i = 0 ; i < keys.length ; i ++ ) {
			// Save the source's descriptor
			descriptor = Object.getOwnPropertyDescriptor( original , keys[ i ] ) ;

			if ( descriptor.value && typeof descriptor.value === 'object' ) {
				// If the value is an object, recursively deepCopy() it
				descriptor.value = this.cloneObj( descriptor.value ) ;
			}

			Object.defineProperty( clone , keys[ i ] , descriptor ) ;
		}

		return clone ;
	}


}
